import { gql, useQuery } from '@apollo/client';
import { BrandKey } from '@prismamedia/one-brandkey';
import {
  GetQualifiersQuery,
  GetQualifiersQueryVariables,
  QualifierStatus,
} from '__generated__/queries-web';
import { getFilteredBrandKey } from 'utils/queries/variables';

export const GET_QUALIFIERS = gql`
  query GetQualifiers(
    $first: UnsignedInt!
    $where: QualifierFilterInput
    $orderBy: [QualifierOrderingInput!]
  ) {
    qualifiers(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      status
      brandKey
    }
  }
`;

export const useQualifiers = (brandKey: BrandKey | null, skip?: boolean) =>
  useQuery<GetQualifiersQuery, GetQualifiersQueryVariables>(GET_QUALIFIERS, {
    variables: {
      first: 100,
      where: {
        status: QualifierStatus.Published,
        ...getFilteredBrandKey(brandKey),
      },
    },
    skip,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
